module.exports = __webpack_public_path__ + "img/orientation-icon.156f6296.svg";